import AttendanceIcon from './AttendanceIcon';

export default AttendanceIcon;